import { AppState, SettingsRequestActions, settingsSelectors } from '@fullstory/redux';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useOrgHistory = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SettingsRequestActions.getSettings());
  }, [dispatch]);

  const orgHistory = useSelector(settingsSelectors.getOrgHistory);
  const orgAnalyticsHistory = useSelector(settingsSelectors.getOrgAnalyticsHistory);
  const retentionTimestamp = useSelector(
    (state: AppState) => state.fullstory.playbackRetentionTimestamp,
  );

  return {
    orgHistory,
    orgAnalyticsHistory,
    retentionTimestamp,
  };
};
